var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('notifications',{attrs:{"group":"msgs"}}),_c('notifications',{attrs:{"group":"msgsCenter","position":"top center"}}),_c('div',{staticClass:"wrapper"},[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }